module.exports = __webpack_public_path__ + "img/2024-03-19e_1.655c5743.jpg";